export default {//default was const... changed to "default" when this became a global mixin
  methods: {
    //FG - FIX Nov 11, 2018 -  BELOW - fix for tabbing after choosing date
    hydroware_picker_hasBlurred(aComponent) {
      aComponent.focus();
      aComponent.hidePicker();
    }
  }
}

   


// WEBPACK FOOTER //
// ./src/hydrowareCommonMixins.js